import Tooltip from '@material-ui/core/Tooltip';
import { localize } from 'commons/LocalizedText/LocalizedText';
import * as PropTypes from 'prop-types';
import React from 'react';

export const CustomTooltip = ({ children, title }) => (
  <Tooltip arrow enterDelay={500} leaveDelay={200} title={typeof title === 'string' ? localize(title) : title}>
    {children}
  </Tooltip>
);

CustomTooltip.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};